import React from "react";

export const Thumbtack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21.017"
      viewBox="0 0 21 21.017"
    >
      <path
        id="thumbtack"
        d="M23.446,7.155l-4.1-4.1A2.617,2.617,0,0,0,14.84,4.964a.311.311,0,0,1-.1.261l-3.27,2.452a4.01,4.01,0,0,1-2.85.681A3.207,3.207,0,0,0,5.667,9.687,3.308,3.308,0,0,0,6.1,13.91l2.657,2.657L3.509,21.812a.857.857,0,0,0,0,1.2.85.85,0,0,0,1.2,0L9.958,17.77,12.6,20.416a3.425,3.425,0,0,0,2.407,1,3.157,3.157,0,0,0,3.145-3.531,4.01,4.01,0,0,1,.681-2.85l2.452-3.27a.311.311,0,0,1,.261-.1,2.617,2.617,0,0,0,1.907-4.507Zm-1,2.327a.905.905,0,0,1-.84.488,1.981,1.981,0,0,0-1.68.783l-2.452,3.27a5.638,5.638,0,0,0-1.01,4.053,1.52,1.52,0,0,1-.636,1.4,1.59,1.59,0,0,1-2.021-.25L7.3,12.718a1.575,1.575,0,0,1-.25-2.021,1.513,1.513,0,0,1,1.238-.636h.159A5.6,5.6,0,0,0,12.5,9.051L15.771,6.6a2.026,2.026,0,0,0,.783-1.68.943.943,0,0,1,.488-.852.969.969,0,0,1,1.124.2l4.1,4.1a.967.967,0,0,1,.2,1.124Z"
        transform="translate(-3.262 -2.248)"
        fill="#4c5a6a"
      />
    </svg>
  );
};
